/* eslint-disable complexity */
import * as validatorPredicates from 'vuelidate/lib/validators';

/*
 * Rules переводит json описание валидации, которое приходит с сервера,
 * в валидацию, понятную для vuelidate.
 * Json из бэка должен быть похож на {"required": null, "between": [20, 30]}
 * Если валидатор vuelidate принимает больше одного значения,
 * в бэке эти параметры должны храниться как массив.
 * Если валидатор не принимает значения, то значение на бэке ставим - null
 */
const getValidator = (name, args) => {
	try {
		if (args === null) {
			return validatorPredicates[name];
		}
		if (typeof args === 'string' || typeof args === 'number' || typeof args === 'boolean') {
			return validatorPredicates[name](args);
		}
		if (Array.isArray(args)) {
			return validatorPredicates[name](...args);
		}

		return null;
	} catch (e) {
		console.error(e);

		return null;
	}
};

const dynamicValidateData = (fields, excludeRules = []) => {
	const validationData = {};
	// eslint-disable-next-line no-restricted-syntax, guard-for-in
	for (const field in fields) {
		if (fields[field]?.hasOwnProperty('children')) {
			const { children } = fields[field];
			// eslint-disable-next-line no-restricted-syntax, guard-for-in
			for (const childField in children) {
				const validation = children[childField]?.validations;
				if (!validation || Array.isArray(validation)) continue;
				validationData[childField] = {};
				try {
					const fieldRules = typeof validation === 'object'
						? validation : JSON.parse(validation);
					Object.keys(fieldRules).forEach((fieldRule) => {
						if (
							typeof getValidator(fieldRule, fieldRules[fieldRule]) === 'function'
							&& !excludeRules.includes(fieldRule)
						) {
							validationData[childField][fieldRule] = getValidator(
								fieldRule, fieldRules[fieldRule],
							);
						} else {
							console.error('Json, хранящий описание валидации, поврежден');
						}
					});
				} catch (e) {
					console.error(e, validation);
				}
			}
		}

		const validation = fields[field]?.validations;
		if (!validation || Array.isArray(validation)) continue;
		validationData[field] = {};
		try {
			const fieldRules = typeof validation === 'object'
				? validation : JSON.parse(validation);
			Object.keys(fieldRules).forEach((fieldRule) => {
				if (
					typeof getValidator(fieldRule, fieldRules[fieldRule]) === 'function'
					&& !excludeRules.includes(fieldRule)
				) {
					validationData[field][fieldRule] = getValidator(fieldRule, fieldRules[fieldRule]);
				} else {
					console.error('Json, хранящий описание валидации, поврежден');
				}
			});
		} catch (e) {
			console.error(e, validation);
		}
	}

	return validationData;
};

export default dynamicValidateData;
